import React, { Component } from 'react'
import modalStyles from '../styles/createModal.module.scss';
import { Row, Col } from 'react-flexbox-grid';
import Button from '../../../components/Button';
import Flatpickr from 'react-flatpickr';
import moment from 'moment';
import Textfield from '../../signup/components/Textfield';
import { X } from 'react-feather';

export default class CustomRecurrenceModal extends Component {

    state = {
        showWeekDays: false,
        showCustomEndDate: false,
        showCustomEndExecutions: false
    }

    onChangeCustomFrequency = (ev) => {
        const { value } =  ev.target;
        this.setState({
            customFrequency: value,
            showWeekDays: value === 'week'
        })
    }

    onChangeCustomEnd = (ev) => {
        const { value } =  ev.target;
        this.setState({
            customEnd: value,
            showCustomEndDate: value === 'date',
            showCustomEndExecutions: value === 'after' 
        })
    }

    render() {
        return (
            <section id={this.props.id} className={[modalStyles.alertPrompt__background, modalStyles.__active, modalStyles.__recurrenceModal].join(' ')}>
                <section className={modalStyles.alertPrompt__card}>
                    <header className={modalStyles.alertPrompt__header}>
                        <Row start="xs" between="xs">
                            <Col xs={12}>
                                <h4>
                                    Custom Recurrence
                                </h4>
                                <span className={modalStyles.alertPrompt__close} onClick={this.props.onClose}>
                                    <X size={24} color="#C61C33"/> 
                                </span>
                            </Col>
                        </Row>
                    </header>
                    <section className={modalStyles.alertPrompt__form}>
                        <Row middle="xs" start="xs">
                                <Col xs={3}>
                                    <span style={{textAlign: 'right'}}>
                                        Every
                                    </span>
                                </Col>
                                <Col xs={3}>
                                    <Textfield
                                        input_type= "number"
                                        meta={{}}
                                    />
                                </Col>
                                <Col xs={6}>
                                    <select name="customFrequency" id="customFrequency" onChange={this.onChangeCustomFrequency}>
                                        <option value="day">days</option>
                                        <option value="week">weeks</option>
                                        <option value="month">months</option>
                                        <option value="year">years</option>
                                    </select>
                                </Col>
                                {this.state.showWeekDays &&
                                    <Col xs={12}>
                                        <span>Su Mo Tu We Th Fr Sa</span>
                                    </Col>
                                }
                                <Col xs={5}>
                                    <h4>Ends</h4>
                                    <select name="frequency" id="frequency" onChange={this.onChangeCustomEnd}>
                                        <option value="never">Never</option>
                                        <option value="date">On date</option>
                                        <option value="after">After</option>
                                    </select>
                                </Col>
                                <Col xs={6}>
                                    {this.state.showCustomEndDate &&
                                        <Flatpickr
                                            defaultValue={moment().toISOString()}
                                            value={moment().toISOString()}
                                            options={{
                                                // minDate: moment().clone().add(1, 'h').toISOString(),
                                                enableTime: true,
                                                altInput: true,
                                                altFormat: 'F j, Y h:i K',
                                                dateFormat: 'Y-m-d H:i'
                                            }}
                                            onChange={date => console.log(date)}
                                        />}
                                    {this.state.showCustomEndExecutions && 
                                        <>
                                            <Textfield
                                            input_type= "number"
                                            meta={{}}/>
                                            <span> executions.</span>
                                        </>
                                    }
                                </Col>
                            </Row>
                            <Row end="xs">
                                <Col xs={4}>
                                    <Button 
                                        label="cancel"
                                        cancel={true}
                                        click={this.props.onClose}
                                    />
                                </Col>
                                <Col xs={4}>
                                    <Button 
                                        type="submit"
                                        login={true}
                                        label="Save"
                                    />
                                </Col>
                            </Row>
                    </section>
                </section>
            </section>
        )
    }
}
